import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Button, Checkbox } from 'antd'
import formCss from '../../common/Form.css'
import css from './Users.css'
import { validatePassword, isPasswordValid } from '../../common/validatePassword'

const EditUserForm = ({
  dso,
  email,
  handleSubmit,
  isTopsAdmin,
  loading,
  locations,
  onInputChange,
  onAddLocation,
  password,
  passwordToCompare,
  userLocations,
  userType,
  userTypes,
}) => {
  const validation = validatePassword(password, passwordToCompare)
  const passwordInvalid =
    isTopsAdmin &&
    (!password || !isPasswordValid(validation))
  const disabled =
    !email ||
    passwordInvalid ||
    (userType === 'location_admin' && !userLocations.length)

  const passwordRules = [
    { key: 'hasCharCount', label: 'Minimum 6 characters' },
    { key: 'hasLowercase', label: 'At least one lowercase letter' },
    { key: 'hasUppercase', label: 'At least one uppercase letter' },
    { key: 'hasNumber', label: 'At least one number' },
    { key: 'hasSymbol', label: 'At least one symbol' },
    { key: 'isStrongPassword', label: 'Strong password (not common/easily guessed)' },
    { key: 'passwordsMatch', label: 'Passwords match' },
  ]
  return (
    <Form
      layout="horizontal"
      onSubmit={handleSubmit}
      className={css.formContainer}
    >
      <h3>New User</h3>
      {dso && locations && (
        <div className="ant-checkbox-modifier">
          {/*
         antd is a giant pain in the neck, you have to wrap it in a class
         to update antd styles. The way that we load our styles in with CSS
         Modules we preface and suffix our styles to prevent overlap. Sadly
         this nullifies the ability to wrap our antd components, so we're left
         with this hacky garbage, should the way to fix this come about. PLZ DO!
        */}
          <style>
            {`.ant-checkbox-modifier .ant-checkbox-wrapper {
              margin-left: 0;
              margin-right: 8px;
            }`}
          </style>
          <Form.Item label="User Type" type="text" className={formCss.input}>
            {userTypes(userType).map(type => (
              <Checkbox
                key={type.label}
                checked={type.checked}
                name="userType"
                onChange={onInputChange}
                value={type.value}
              >
                {type.label}
              </Checkbox>
            ))}
          </Form.Item>
          {userType === 'location_admin' && (
            <Form.Item
              label="User Location"
              type="text"
              className={formCss.input}
            >
              {locations.map(location => (
                <Checkbox
                  key={location.name}
                  checked={userLocations.includes(location.id)}
                  name="userLocations"
                  onChange={onAddLocation}
                  value={location.id}
                >
                  {location.name}
                </Checkbox>
              ))}
            </Form.Item>
          )}
        </div>
      )}
      <Form.Item label="E-mail" type="email" className={formCss.input}>
        <Input value={email} name="email" onChange={onInputChange} />
      </Form.Item>
      {isTopsAdmin && (
        <React.Fragment>
          <Form.Item label="Password" type="password" className={formCss.input}>
            <Input
              type="password"
              value={password}
              name="password"
              onChange={onInputChange}
            />
          </Form.Item>
          <Form.Item
            label="Confirm Password"
            type="password"
            className={formCss.input}
          >
            <Input
              type="password"
              value={passwordToCompare}
              name="passwordToCompare"
              onChange={onInputChange}
            />
          </Form.Item>
          <ul className={css.passwordRules}>
            {passwordRules.map(({ key, label }) => {
              let ruleClass = css.passwordRule
              if (password) {
                ruleClass = validation[key] ? css.passwordRuleMet : css.passwordRuleFailed
              }
              return (
                <li key={key} className={ruleClass}>
                  {validation[key] ? '✓' : '✗'} {label}
                </li>
              )
            })}
          </ul>
        </React.Fragment>
      )}
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          disabled={disabled}
          icon="plus"
          loading={loading}
        >
          Add User
        </Button>
      </Form.Item>
      {!isTopsAdmin && (
        <i>
          *New users will be sent an email with a link to set up password.
          Set up password link is valid for one week.
        </i>
      )}
    </Form>
  )
}

EditUserForm.propTypes = {
  dso: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isTopsAdmin: PropTypes.bool.isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    practice_id: PropTypes.number.isRequired,
  })).isRequired,
  loading: PropTypes.bool.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onAddLocation: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  passwordToCompare: PropTypes.string.isRequired,
  userLocations: PropTypes.arrayOf(PropTypes.string),
  userType: PropTypes.string.isRequired,
  userTypes: PropTypes.func.isRequired,
}

EditUserForm.defaultProps = {
  userLocations: null,
}

export default EditUserForm



// WEBPACK FOOTER //
// ./src/AddPractice/Users/EditUserForm.js